/**
 * @generated SignedSource<<889c2ddcb711c11db63a733be7edf2ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BookPublishersFilter = {
  search?: string | null;
};
export type BookPublisherSearchOverlayField_bookPublishersQuery$variables = {
  filters?: BookPublishersFilter | null;
};
export type BookPublisherSearchOverlayField_bookPublishersQuery$data = {
  readonly bookPublishers: ReadonlyArray<string>;
};
export type BookPublisherSearchOverlayField_bookPublishersQuery = {
  response: BookPublisherSearchOverlayField_bookPublishersQuery$data;
  variables: BookPublisherSearchOverlayField_bookPublishersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filters",
        "variableName": "filters"
      }
    ],
    "kind": "ScalarField",
    "name": "bookPublishers",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookPublisherSearchOverlayField_bookPublishersQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookPublisherSearchOverlayField_bookPublishersQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9a4955aa2f8a1d6ba5f8ddd512959a0c",
    "id": null,
    "metadata": {},
    "name": "BookPublisherSearchOverlayField_bookPublishersQuery",
    "operationKind": "query",
    "text": "query BookPublisherSearchOverlayField_bookPublishersQuery(\n  $filters: BookPublishersFilter\n) {\n  bookPublishers(filters: $filters)\n}\n"
  }
};
})();

(node as any).hash = "31ecd8dc8efe309c0959f0d18a83c18d";

export default node;
